module.exports = __webpack_public_path__ + "img/dgm.cf9f63b7.png";